import { render, staticRenderFns } from "./AxisCameraCard.vue?vue&type=template&id=288261bb&scoped=true"
import script from "./AxisCameraCard.vue?vue&type=script&lang=js"
export * from "./AxisCameraCard.vue?vue&type=script&lang=js"
import style0 from "./AxisCameraCard.vue?vue&type=style&index=0&id=288261bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288261bb",
  null
  
)

export default component.exports